import { useMetadataUser } from "contexts/metadata-user-context";
import { ReactNode, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getCookie, removeCookie } from "utils/functions-cookie";

type Props = {
  children: ReactNode;
  redirectTo?: string;
};

const PUBLIC_ROUTES = new Set([
  "/login",
  "/signup",
  "/forgot-password",
  "/",
  "form-forgot-password",
]);

const ROUTES_THAT_A_SUBSCRIBER_SHOULD_NOT_ACCESS = new Set(["/plans"]);

export const PrivateRoute = ({ children, redirectTo }: Props) => {
  const isAuthenticated = !!getCookie("auth_token");
  const refreshToken = !!getCookie("refresh_token");
  const { profile } = useMetadataUser();

  const navigation = useNavigate();
  const pathname = useLocation().pathname;

  useEffect(() => {
    if (!isAuthenticated) {
      if (!PUBLIC_ROUTES.has(pathname)) {
        window.location.href = `${redirectTo ?? "/login"}`;
        return;
      }
    }

    if (isAuthenticated && !refreshToken) {
      removeCookie("auth_token");
      window.location.href = "/login";
      return;
    }

    if (isAuthenticated && refreshToken) {
      if (PUBLIC_ROUTES.has(pathname)) {
        navigation("/home");
        return;
      }

      if (
        profile?.subscription?.active &&
        ROUTES_THAT_A_SUBSCRIBER_SHOULD_NOT_ACCESS.has(pathname)
      ) {
        navigation("/home");
        return;
      }
    }

    return () => {};
  }, [
    isAuthenticated,
    navigation,
    redirectTo,
    refreshToken,
    pathname,
    profile,
  ]);

  if (!isAuthenticated) {
    return null;
  }

  if (isAuthenticated && !refreshToken) {
    return null;
  }

  if (isAuthenticated && refreshToken) {
    if (PUBLIC_ROUTES.has(pathname)) {
      return null;
    }

    if (
      profile?.subscription?.active &&
      ROUTES_THAT_A_SUBSCRIBER_SHOULD_NOT_ACCESS.has(pathname)
    ) {
      return null;
    }
  }

  return <>{children}</>;
};
